import PropTypes from "prop-types";
import React from "react";

const NotFoundError = (props) => {
  return (
    <div className="erg-margin-15 text-danger">
      <h3>Not Found</h3>
      {props.children ? props.children : props.message}
    </div>
  );
};

NotFoundError.propTypes = {
  children: PropTypes.node,
  message: PropTypes.instanceOf(String),
};

export default NotFoundError;



/** WEBPACK FOOTER **
 ** ./src/app/v2/components/NotFoundError.js
 **/